import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

export const Header = styled.header`
  width: 100%;
  border-radius: 0 0 8px 8px;
  padding: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.neutral_700};
`;

export const LogoWrapper = styled.div`
  height: 100%;
  width: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.neutral_100};
  svg {
    width: 100%;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 64px 0 0;
  gap: 12px;
  align-items: center;
  height: 100vh;
`;
